// JsFromRoutes CacheKey 42c5e08eef8f59078b6a1f6c830def7c
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  cardAccess: /* #__PURE__ */ definePathHelper('get', '/card/access'),
  cardBlocked: /* #__PURE__ */ definePathHelper('get', '/card/blocked'),
  createSessionForOtp: /* #__PURE__ */ definePathHelper('post', '/card/access/create_session_for_otp'),
  resendOtpForSession: /* #__PURE__ */ definePathHelper('post', '/card/access/resend_otp_for_session'),
  validateSessionOtp: /* #__PURE__ */ definePathHelper('post', '/card/access/validate_session_otp'),
  selectCard: /* #__PURE__ */ definePathHelper('post', '/card/access/select_card'),
  listCardsForSelection: /* #__PURE__ */ definePathHelper('get', '/card/access/list_cards_for_selection'),
  sessionTokenStatus: /* #__PURE__ */ definePathHelper('get', '/card/access/session_token_status'),
  deliverEmailForCardSelection: /* #__PURE__ */ definePathHelper('post', '/card/access/deliver_email_for_card_selection'),
}
